declare let __webpack_public_path__: string;

/**
 * Sets the Webpack public path as describe in:
 * https://webpack.js.org/configuration/output/#output-publicpath
 */
export const setWebpackPublicFromBackend = () => {
  __webpack_public_path__ = window.backend.assetBaseUrl + '/';
};
